import { Stack } from 'expo-router';
import { Platform, useWindowDimensions } from 'react-native';

import { getScreenTitleHeader } from '../../../components/get-screen-title-header';

const reorderHeader = getScreenTitleHeader({
  backStyle: Platform.OS === 'web' ? 'back' : 'none',
  cannotGoBackHref: '/account',
});

export default function ReorderLayout() {
  const { width } = useWindowDimensions();
  const isDesktopWeb = Platform.OS === 'web' && width >= 768;

  return (
    <Stack
      screenOptions={{
        header: reorderHeader,
        headerShown: !isDesktopWeb,
      }}
    >
      <Stack.Screen name="account/orders" options={{ title: 'Recent Orders' }} />
    </Stack>
  );
}
